

class Product {
   constructor(ipNumber, isbn, title, category, priceCad, priceUsd, type) {
      if (this.constructor === Product) {
         throw new Error('Abstract class cannot be instantiated');
      }

      this.ipNumber = this.validateIpNumber(ipNumber);
      this.isbn = isbn;
      this.title = this.validateTitle(title);
      this.category = category;
      this.priceCad = this.validatePrice(priceCad);
      this.priceUsd = this.validatePrice(priceUsd);
      this.type = type;
   }

   validateIpNumber(ipNumber) {
      if (!ipNumber) {
         throw new Error('The IP Number cannot be left empty');
      }
      return ipNumber;
   }

   validateTitle(title) {
      if(!title) {
         throw new Error('The title cannot be left empty');
      }
      return title;
   }

   validatePrice(val) {
      if (typeof Number(val) !== 'number' && typeof val !== 'number') {
         throw new Error('The price is invalid. It should be a number');
      }
      return Number(val);
   }
}

export default Product;